module.exports = __webpack_public_path__ + "img/KR.793c8ae2.svg";